var Storage = (function () {
    var globalState;
    var advanceState;
    var homePageState;
    var pickList;
    var ESCount;
    var AllRequests;
    var lovBoundedList;
    var allCountryList;

    var getAllCountryList = function (){
        return allCountryList
    };

    var setAllCountryList = function (countries){
        allCountryList = countries
    };

    var getLovBoundedList = function () {
        return lovBoundedList;
    };

    var setLovBoundedList = function (newValue) {
        lovBoundedList = newValue;
    };

    var getAllRequests = function () {
        return AllRequests;
    };

    var setAllRequests = function (newAllRequests) {
        AllRequests = newAllRequests;
    };

    var getHomePageState = function () {
        return homePageState;
    };

    var setHomePageState = function (newState) {
        homePageState = newState;
    };
    var getESCount = function () {
        return ESCount;
    };

    var setESCount = function (newState) {
        ESCount = newState;
    };

    var getGlobalData = function () {
        return globalState;
    };

    var setGlobalData = function (newGlobalState) {
        globalState = newGlobalState;
    };

    var getAdvanceData = function () {
        return advanceState;
    };

    var setAdvanceData = function (newAdvanceState) {
        advanceState = newAdvanceState;
    };

    var getPickList = function () {
        return pickList;
    };

    var setPickList = function (newPicklist) {
        pickList = newPicklist;
    };

    return {
        getGlobalName: getGlobalData,
        setGlobalName: setGlobalData,
        getAdvanceName: getAdvanceData,
        setAdvanceName: setAdvanceData,
        getHomePageState: getHomePageState,
        setHomePageState: setHomePageState,
        setPickList: setPickList,
        getPickList: getPickList,
        getCount: getESCount,
        setCount: setESCount,
        getAllRequests: getAllRequests,
        setAllRequests: setAllRequests,
        getLovBoundedList: getLovBoundedList,
        setLovBoundedList: setLovBoundedList,
        setAllCountryList: setAllCountryList,
        getAllCountryList: getAllCountryList
    }

})();

export default Storage;